import React from 'react'

import { withRouter } from 'react-router-dom';

import { Section, InfosBar, Version } from 'components';
import { Container, Button, Label, Dropdown, Card, Breadcrumb } from 'semantic-ui-react'

import { ModalOptions, ModalChangelogEntry } from 'modals';

import { EnumChannel } from 'enums';

import { BreadcrumbHelper, Typeof, DraftUtils } from 'utils';
import { API } from 'services';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import compareVersion from 'compare-versions';

import moment from 'moment';

import './style.css';

const NO_FILTER = "none";

class ChangelogScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      entries: props.entries,
      channelFilter: NO_FILTER,
      searchCriteria: '',
      targetEntry: null,
      showCreateModal: false,
      showEditModal: false,
      showDeleteModal: false
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleFilter = this.handleFilter.bind(this);

    this.toggleCreateModal = this.toggleCreateModal.bind(this);
    this.handleCreateModalClose = this.handleCreateModalClose.bind(this);

    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.handleEditModalClose = this.handleEditModalClose.bind(this);

    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push("Changelog application");

    const params = new Map(this.props.location.search.slice(1).split('&').map(kv => kv.split('=')))

    if(params.has('channel')) {

      let channel = params.get('channel').trim();

      this.setState({
        channelFilter: channel
      });
    }

    BreadcrumbHelper.flush();
  }

  handleSearch(criteria) {

    this.setState({
      searchCriteria: criteria
    });
  }

  handleFilter(event, { value }) {

    this.setState({
      channelFilter: value
    }, this.reloadData);
  }

  toggleCreateModal() {

    //Show modal
    this.setState({
      showCreateModal: !this.state.showCreateModal
    });
  }

  handleCreateModalClose(entry) {

    if(Typeof.object(entry)) {

      //Update locally
      this.setState({
        entries: [...this.state.entries, entry]
      });
    }

    //Hide modal
    this.toggleCreateModal();
  }

  toggleEditModal(entry) {

    //Show modal
    this.setState({
      targetEntry: entry,
      showEditModal: !this.state.showEditModal
    });
  }

  handleEditModalClose(update) {

    if(Typeof.object(update)) {

      //Update locally
      let entries = this.state.entries.map((entry) => {

        if(entry.version === update.version && entry.channel === update.channel) {
          entry.content = update.content;
        }

        return entry;
      });

      this.setState({
        entries: entries
      });
    }

    //Hide modal
    this.toggleEditModal();
  }

  toggleDeleteModal(entry = null) {

    //Show modal
    this.setState({
      targetEntry: entry,
      showDeleteModal: !this.state.showDeleteModal
    });
  }

  handleDeleteModalClose(result, setProcessing) {

    if(result !== ModalOptions.OPTION_YES) {
      this.toggleDeleteModal();
    } else {

      setProcessing(true);

      let toDelete = this.state.targetEntry;

      API.delete(`/changelogs/${toDelete.channel}/${toDelete.version}`)
        .then(() => {

          //Remove locally
          let entries = this.state.entries.filter((entry) => {

            return entry.version !== toDelete.version || entry.channel !== toDelete.channel;
          });

          this.setState({
            entries: entries,
            targetEntry: null,
            showDeleteModal: false
          });

        });
    }
  }

  getEntries(entries) {

    let availabeEntries = entries;
    let results = [];

    if(availabeEntries.length > 0) {

      //Filter
      availabeEntries = availabeEntries.filter((entry) => {

        return this.state.channelFilter === NO_FILTER || entry.channel === this.state.channelFilter;
      });

      let criteria = this.state.searchCriteria.toLowerCase();

      //Search
      if(Typeof.string(criteria) && criteria.length > 0) {

        results = availabeEntries.filter((entry) => {

          let fields = [
            entry.version,
            EnumChannel.name(entry.channel),
            moment(entry.date).format('DD/MM/YYYY'),
            moment(entry.date).format('HH:mm:ss')
          ]

          if(entry.content && entry.content.length > 0) {
            fields.push(entry.content.replace(/(<([^>]+)>)/gi, ""));
          }

          return fields.some((v) => v.toLowerCase().includes(criteria));
        })

      } else {
        results = availabeEntries;
      }

      //Sort newer first
      results.sort((a, b) => {
        return compareVersion(b.version, a.version);
      });
    }

    return results;
  }

  render() {

    let entries = this.getEntries(this.state.entries);

    let channelsFilter = [{
      key: NO_FILTER,
      value: NO_FILTER,
      text: "Tous"
    }];

    EnumChannel.values.forEach((channel) => {
      channelsFilter.push({
        key: channel,
        value: channel,
        text: EnumChannel.name(channel)
      });
    });

    return (
      <React.Fragment>

        <Container>

          {/* Firmwares */}
          <Section empty title="Changelog application" onSearch={this.handleSearch} criteria={this.state.firmwareCriteria} actions={[

            // Add firmware
            <Button icon="add" content="Ajouter" onClick={this.toggleCreateModal} />
          ]}>

          </Section>

        </Container>

        <Container id="changelogs">

          {entries.length > 0 ? (

            <React.Fragment>

              {/* Number of available entries */}
              <InfosBar mode="column">
                <span>{entries.length > 1 ? `${entries.length} entrées disponibles` : '1 entrée disponible'}</span>

                {/* Channel filter */}
                <Dropdown icon="filter" value={this.state.channelFilter} options={channelsFilter} onChange={this.handleFilter} direction='left' key={0} />
              </InfosBar>

              {entries.map((entry) => {

                let version = `${entry.version}_${entry.channel}`;

                return (
                  <Card id={version} className="entry" fluid raised color={EnumChannel.color(entry.channel)} key={entry.id}>
                    <Card.Content>

                      <Card.Header>

                        {/* Version number */}
                        <Version version={version} />

                        {/* Actions */}
                        <Breadcrumb size="mini" className="actions">

                          {/* Edit */}
                          <Breadcrumb.Section link onClick={() => this.toggleEditModal(entry)}>
                            Modifier
                          </Breadcrumb.Section>

                          <Breadcrumb.Divider />

                          {/* Delete */}
                          <Breadcrumb.Section link onClick={() => this.toggleDeleteModal(entry)}>
                            Supprimer
                          </Breadcrumb.Section>
                        </Breadcrumb>

                      </Card.Header>

                      {/* Date */}
                      <Card.Meta className="date">
                        {moment(entry.date).format('[Le] DD/MM/YYYY [à] HH:mm:ss')}
                      </Card.Meta>

                      {/* Content */}
                      <Card.Description>

                        <Editor toolbarHidden readOnly editorState={DraftUtils.HTML2EditorState(entry.content)} />

                      </Card.Description>

                    </Card.Content>
                  </Card>
                );
              })}
            </React.Fragment>

          ) : (

            // No changelog entry available
            <InfosBar mode="column">
              <span>Aucune entrée disponible</span>

                {/* Channel filter */}
                <Dropdown icon="filter" value={this.state.channelFilter} options={channelsFilter} onChange={this.handleFilter} direction='left' key={0} />
            </InfosBar>

          )}

        </Container>

        {/* Entry create modal */}
        {this.state.showCreateModal &&
          <ModalChangelogEntry onClose={this.handleCreateModalClose} />
        }

        {/* Entry edit modal */}
        {this.state.showEditModal &&
          <ModalChangelogEntry entry={this.state.targetEntry} onClose={this.handleEditModalClose} />
        }

        {/* Entry delete warning modal */}
        {this.state.showDeleteModal &&
          <ModalOptions onClose={this.handleDeleteModalClose} icon="trash alternate" title="Suppression" message={<span>Vous êtes sur le point de supprimer cette entrée.<br /><br />Voulez vous continuer ?</span>} options={ModalOptions.OPTIONS_YESCANCEL} />
        }

      </React.Fragment>
    );
  }
}

export default withRouter(ChangelogScene);
